import { store } from '@src/state/store';
import { onKick } from '@src/state/slices/slice_game';

export default () => (data: any) => {
  if (!data || !data.gameId) return;

  console.log('KICKED');
  store.dispatch(onKick({ gameId: data.gameId }));
};
